import React from 'react';
import { Card, Form, Input, Select, Space } from 'antd';

const { Option } = Select;

const timeRangeOptions = [
  { label: '一天内', value: 1 },
  { label: '一周内', value: 7 },
  { label: '一个月内', value: 30 }
];

const MobileFilterBar = ({ form, onValuesChange }) => (
  <Card bordered={false} style={{ marginBottom: 16 }}>
    <Form
      form={form}
      layout="vertical"
      initialValues={{ timeRange: 7, curr_status: '0' }}
      onValuesChange={onValuesChange}
    >
      <Space size="middle" wrap>
        <Form.Item name="bank_trade_code" label="流水号" style={{ marginBottom: 0 }}>
          <Input placeholder="输入流水号" allowClear style={{ width: 240 }}/>
        </Form.Item>
        <Form.Item name="timeRange" label="时间范围" style={{ marginBottom: 0 }}>
          <Select style={{ width: 120 }}>
            {timeRangeOptions.map(option => (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="curr_status" label="状态" style={{ marginBottom: 0 }}>
          <Select style={{ width: 100 }}>
            <Option value="0">全部</Option>
            <Option value="1">待处理</Option>
            <Option value="2">处理中</Option>
            <Option value="3">处理完成</Option>
          </Select>
        </Form.Item>
      </Space>
    </Form>
  </Card>
);

export default MobileFilterBar;